import { getKeycloakInstance } from '../keycloak/keycloak-init';

export const handleLogout = () => {
  const kcInstance = getKeycloakInstance();
  if (kcInstance) kcInstance.logout();
};
